<template>
    <div>
       <h4 class="title">回饋金查詢</h4>
         <form class="form-inline">
           <div class="form-group">
             <datepicker v-model="choosemonth" language="zh" format="yyyy-MM" placeholder="可查詢不同月份"></datepicker>
           </div>
           <div class="form-group">
             <button type="button" class="btn btn-sm btn-success" :disabled="this.searchFlag" @click="getPerformance()">查詢</button>
           </div>

           <div class="form-group">
            <span>志工點數餘額： {{this.volunteerQuota}} </span>            
           </div>
           <div class="form-group">
             <input type="number" min="0" v-model="redeenvolunteerQuota" placeholder="請輸入預計折抵點數"/>
           </div>
           <div class="form-group">
             <button type="button" class="btn btn-sm btn-success" :disabled="this.redeenFlag" @click="redeenVolunteer()">確認折抵</button>
           </div>
         </form>
       <div class="member_content">
            <table class="table table-bordered">
                <thead>
                    <tr class="success">
                        <td></td>
                        <td>編號</td>
                        <td>姓名</td>
                        <td>總消費額</td>
                        <td>總點數</td>
                        <td></td>
                        <td>回饋金</td>
                    </tr>
                </thead>
                <tbody>
                    <tr class="even" role="row" v-for="(row, index) in this.performance">
                      <td>{{row.level}}</td>
                      <td>{{row.org_mid}}</td>
                      <td>{{row.org_name}}</td>
                      <td v-if="row.level===0">
                      總額: {{row.price}}<br/>
                      一般商品:{{row.bonusL}}<br/>
                      指定商品:{{row.bonusH}}
                      </td>
                      <td v-else>{{row.price}}</td>
                      <td v-if="row.level===0">{{row.point}}</td>
                      <td v-else>{{Math.round(row.point,3)}}</td>
                      <td>{{row.percentage}}%</td>
                      <td v-if="row.level===0">
                        {{row.person_bonus}}
                      </td>
                      <td v-else>
                        {{Math.round(row.bonus * 100)/100}}
                      </td>
                    </tr>
                </tbody>
                <tfoot>
                  <tr>
                    <td colspan="7">
                      最高可領金額: {{this.Minimum}} 元<br/>
                      (本月已折抵志工點數 : {{this.personalMaxBonus}}) <br/><br/>
                      個人回饋金: {{this.personal}}<br/>
                      組織回饋金: {{Math.round(this.group*100)/100}}<br/>
                      總計回饋金: {{Math.round(this.totalBonus,3)}} 元
                    </td>
                  </tr>
                </tfoot>
            </table>
      </div>
    </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import Datepicker from 'vuejs-datepicker'
import moment from 'moment'

export default {
  components: {
    Datepicker
  },
  name: 'Performance',
  data () {
    return {
      memberurl: this.$store.getters.getMemberAPI,
      userID: this.$store.getters.getUserID,
      token: this.$store.getters.getToken,
      volunteerQuota: this.$store.getters.getVolunteerQuota,
      performance: [],
      choosemonth: '',
      person_bonus: 0,
      totalBonus: 0,
      personal: 0,
      group: 0,
      Minimum: 0,
      redeenvolunteerQuota: 0,
      personalMaxBonus: 0,
      searchFlag: false,
      redeenFlag: false
    }
  },
  mounted: function () {
  },
  methods: {
    ...mapActions([
      'GET_NEWS'
    ]),
    getPerformance () {
      let date = new Date(this.choosemonth)
      let queryDate = date.getFullYear() + '-' + ('0' + (date.getMonth() + 1)).slice(-2)
      this.searchFlag = true
      this.$http.get(this.memberurl + '/member_performance', {params: {token: this.token, month: queryDate}}).then(function (res) {
        this.searchFlag = false
        let data = res.body.data
        let companyAmount = data[0].companyAmount // 廠商提撥金
        let personalMaxBonus = data[0].personal_max_bonus // 志工點數扣抵
        this.personalMaxBonus = personalMaxBonus
        this.performance = data
        this.totalBonus = data[0].totalBonus
        this.Minimum = parseInt(data[0].point * 2) + companyAmount + personalMaxBonus
        this.personal = data[0].personal
        this.person_bonus = data[0].person_bonus
        this.group = data[0].group
      }, function () {
        console.log('failed')
      })
    },
    redeenVolunteer () {
      this.redeenFlag = true
      this.$http.post(this.memberurl + '/redeenVolunteer', {
        redeenvolunteerQuota: this.redeenvolunteerQuota,
        token: this.token
      }).then(function (res) {
        console.log(res)
        this.redeenFlag = false

        let response = res.body
        if (response.status === 200) {
          window.alert('折抵成功')
        } else {
          window.alert('折抵失敗:' + response.message)
        }
        this.redeenFlag = false
      }, function () {
        console.log('failed')
      })
    }
  },
  computed: {
    ...mapGetters([
      'getNews'
    ])
  },
  filters: {
    formatMonth: function (date) {
      return moment(date).format('MM')
    }
  }
}
</script>



// WEBPACK FOOTER //
// Performance.vue?959ce914